import gql from 'graphql-tag'

export const VERIFY_OTP = gql`
  query sendOtp($uniqueId: uuid!,$otp:bigint!){
    sendOtp(where: {uniqueId: {_eq: $uniqueId}, _and: {otp: {_eq: $otp}}}) {
    id
    otp
  }
  }
`
